import React, { useState, useContext, useMemo, useEffect, useRef } from "react";
import { useLocation, useHistory } from 'react-router-dom';
import 'react-tabs/style/react-tabs.css';
import { Header } from "../../../components/Header";
import { Menu } from "../../../components/Menu";
import { MenuPage } from "../../../components/MenuPage";
import { get, set, useForm } from 'react-hook-form';
import { StyledVisibillidadePage } from "../../../styled-components/StyledVisibillidadePage.style";
import { StyledForm } from "../../../styled-components/StyledFormVisibilidade.style";
import { MobileContext } from "../../../contexts/MobileContext";
import "react-datepicker/dist/react-datepicker.css";
import "bootstrap/dist/css/bootstrap.min.css";
import api from '../../../services/api';
import * as moment from 'moment'
import {
    IconArrowAngleLeft, IconArrowAngleRight, IconRefresh, IconFlag, IconPlay, IconComments, IconCaretDown, IconCaretUp,
    IconFileCirclePlus, IconArrowRightArrowLeft, IconBan, IconCheckToSlot, IconBoltLightning, IconClockRotateLeft, IconGear
} from "../../../svg";
import { ToggleSwitchFilters } from "../../../components/ToggleSwitchFilters";
import { DynamicInput } from "../../../components/DynamicInput";
import { Multiselect } from 'multiselect-react-dropdown';
import { DynamicSelect } from "../../../components/DynamicSelect";
import DatePicker from "react-datepicker";
import { PaginationCustom } from "../../../components/PaginationCustom";

import { TimelineVisibilidade } from '../../../components/TimelineVisibilidade';
import { getVisibilidadeJornadas, getVisibilidadeEtapas, getVisibilidadeMacroEtapas, getGeneriList, getOptionAllVisibilidade } from '../../../services/visibilidade';
import { getSinisterTypes , getDepartamentTypes } from '../../../services/sinistro';
import { getClients } from '../../../services/clientes';
import { getDisciplinas } from '../../../services/disciplinas';
import { getPeritos } from '../../../services/peritos';

import { ModalVisibilidadeAcoes } from "../../../components/ModalVisibilidadeAcoes";
import { ModalVisibilidadeTarefas } from "../../../components/ModalVisibilidadeTarefas";
import { ModalVisibilidadeTransferir } from "../../../components/ModalVisibilidadeTransferir";
import { ModalVisibilidadeAceitar } from "../../../components/ModalVisibilidadeAceitar";
import { ModalVisibilidadeIniciar } from "../../../components/ModalVisibilidadeIniciar";
import { ModalVisibilidadeCancelar } from "../../../components/ModalVisibilidadeCancelar";
import { ModalVisibilidadePriorizacao } from "../../../components/ModalVisibilidadePriorizacao";
import { ModalVisibilidadeExportar } from "../../../components/ModalVisibilidadeExportar";
import { ModalVisibilidadeMensagens } from "../../../components/ModalVisibilidadeMensagens";
import { ModalVisibilidadeRenovar } from "../../../components/ModalVisibilidadeRenovar";
import { ModalVisibilidadeDRL } from "../../../components/ModalVisibilidadeDRL";
import { ModalVisibilidadeConfiguracoes } from "../../../components/ModalVisibilidadeConfiguracoes";

let controllerTS;
const requestGetListaVisibilidade = async (params) => {
    if (controllerTS) {
        controllerTS.abort();
    }

    controllerTS = new AbortController();
    const signal = controllerTS.signal;

    let list = null;
    try {
        const response = await api.get(`Visibilidade/list?${params}&_t=${new Date().getTime()}`, { signal });
        list = response.data;
        return list;
    } catch (err) {
        return list;
    }
}

const useQuery = () => {
    return new URLSearchParams(useLocation().search);
}

const getQueryParams = (query) => {
    const params = {};
    for (let [key, value] of query.entries()) {
        if (params[key]) {
            params[key] = [].concat(params[key], value);
        } else {
            params[key] = value;
        }
    }
    return params;
}

export const Visibilidade = () => {
    var [searchReadOnly, setSearchReadOnly] = useState(false);
    var [searchInput, setSearchInput] = useState(null);
    var [loadingData, setLoadingData] = useState(true);
    var [pageSize, setPageSize] = useState(300);
    const [currentPage, setCurrentPage] = useState(0);

    var [idEmpresa, setIdEmpresa] = useState(1);
    var [idEmpresaIndexTab, setIdEmpresaIndexTab] = useState(0);
    const [filtersCount, setFiltersCount] = useState([]);
    const [filterCountsSub, setFilterCountsSub] = useState([]);

    const isMobile = useContext(MobileContext);
    const isDesktop = !isMobile;
    const multiselectRef = useRef();
    const history = useHistory();
    const query = useQuery();
    const queryParams = getQueryParams(query);
    const { register, handleSubmit, reset, setValue, getValues } = useForm();

    const [visibilidadeAllOptions, setVisibilidadeAllOptions] = useState([]);

    const [defaultSetted, setDefaultSetted] = useState(null);
    const [VisibilidadeData, setVisibilidadeData] = useState(null);

    const [todosProcessosChecked, setTodosProcessosChecked] = useState(false);
    const [todaMinhaAreaChecked, setTodaMinhaAreaChecked] = useState(false);
    const [processosEmAndamentoChecked, setProcessosEmAndamentoChecked] = useState(false);
    const [legendaEmAndamentoView, setLegendaEmAndamentoView] = useState("Processos Encerrado");
    const [tabelaChecked, setTabelaChecked] = useState(false);
    const [legendaTableView, setLegendaTableView] = useState("Tabela");
    const [pesquisaAvancadaChecked, setPesquisaAvancadaChecked] = useState(false);
    const [historicoChecked, setHistoricoChecked] = useState(false);
    const [cronometroChecked, setCronometroChecked] = useState(false);
    const [itemDetalheChecked, setItemDetailheChecked] = useState(false);
    const [itemSelecionadoId, setItemSelecionadoId] = useState(null);
    const [semLiderResponsavelChecked, setSemLiderResponsavelChecked] = useState(false);

    const [itensExpandidos, setItensExpandidos] = useState([]);
    const [tarefasPorProcesso, setTarefasPorProcesso] = useState({});
    const [historicoAtivoPorProcesso, setHistoricoAtivoPorProcesso] = useState([]);

    const [processoList, setProcessoList] = useState([]);

    var [cliente, setCliente] = useState(null);
    var [idCliente, setIdCliente] = useState(null);
    const [clientList, setClientList] = useState([]);

    var [disciplina, setDisciplina] = useState(null);
    var [idDisciplinas, setDisciplinasId] = useState([]);
    const [disciplinaDefaultValue, setDisciplinaDefaultValue] = useState([]);
    const [disciplinaList, setDisciplinaList] = useState([]);

    var [perito, setPerito] = useState(null);
    var [idPeritos, setPeritosId] = useState([]);
    const [peritosList, setPeritosList] = useState([]);

    const [peritosListDefaultValue, setPeritosListDefaultValue] = useState([]);

    var [etapa, setEtapa] = useState(null);
    var [idEtapa, setIdEtapa] = useState(null);
    const [etapasList, setEtapasList] = useState([]);

    var [macroEtapa, setMacroEtapa] = useState(null);
    var [idMacroEtapa, setIdMacroEtapa] = useState(null);
    const [macroEtapasList, setMacroEtapasList] = useState([]);
    const [macroEtapaIds, setMacroEtapaIds] = useState([]);

    const [tarefasList, setTarefasList] = useState([]);
    const [getTarefasList, setGetTarefasList] = useState([]);

    var [statusTarefa, setStatusTarefa] = useState(null);
    var [idStatusTarefa, setIdStatusTarefa] = useState([]);
    const [selectedStatusTarefa, setSelectedStatusTarefa] = useState([]);
    const [statusTarefaType, setStatusTarefaType] = useState([]);

    var [tipoCronometro, setTipoCronometro] = useState(null);
    var [idTipoCronometro, setIdTipoCronometro] = useState(null);
    const [tipoCronometroType, setTipoCronometroType] = useState([]);

    var [tipoSinistro, setTipoSinistro] = useState(null);
    var [idTipoSinistro, setIdTipoSinistro] = useState(null);
    const [tipoSinistroType, setTipoSinistroType] = useState([]);

    var [porteSinistro, setPorteSinistro] = useState(null);
    var [idPorteSinistro, setIdPorteSinistro] = useState(null);
    const [porteSinistroType, setPorteSinistroType] = useState([]);

    var [tipoPrioridade, setTipoPrioridade] = useState(null);
    var [idTipoPrioridade, setIdTipoPrioridade] = useState(null);
    const [tipoPrioridadeType, setTipoPrioridadeType] = useState([]);

    var [statusProcesso, setStatusProcesso] = useState(null);
    var [idStatusProcesso, setIdStatusProcesso] = useState(null);
    const [statusProcessoType, setStatusProcessoType] = useState([]);

    var [documentacaoPendente, setDocumentacaoPendente] = useState(null);
    var [idDocumentacaoPendente, setIdDocumentacaoPendente] = useState(null);
    const [documentacaoPendenteType, setDocumentacaoPendenteType] = useState([]);

    var [cronometro, setCronometro] = useState(null);
    var [idStatusCronometro, setIdStatusCronometro] = useState(null);
    const [cronometroType, setCronometroType] = useState([]);

    const [coberturaStatusType, setCoberturaStatusType] = useState([]);
    const [statusDocumentacao, setStatusDocumentacao] = useState([]);

    var [jornada, setJornada] = useState(null);
    var [idJornada, setIdJornada] = useState(null);
    const [jornadas, setJornadas] = useState([]);
    const [jornadasList, setJornadasList] = useState([]);
    const [jornadaIds, setJornadaIds] = useState([]);
    const [idJornadas, setJornadasId] = useState([]);

    const [sinalizadores, setSinalizadores] = useState([]);

    const [currentIndex, setCurrentIndex] = useState(0);
    const trackRef = useRef(null);
    const visibleItems = 10; // Itens visíveis de uma vez
    const totalItems = macroEtapasList.length; // Total de itens (15)
    const maxSteps = totalItems > visibleItems ? totalItems - visibleItems : 0;

    const submitButtonPesquisaAvanca = useRef(null)

    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndtDate] = useState(null);

    const [selectedProcesso, setSelectedProcesso] = useState([]);
    const [selectedTarefa, setSelectedTarefa] = useState([]);
    const [selectedProcessoLaudo, setSelectedProcessoLaudo] = useState([]);
    const [modalIdProcesso, setModalIdProcesso] = useState(null);
    const [modalVisibilidadeAcoes, setModalVisibilidadeAcoes] = useState(false);
    const [modalVisibilidadeTransferir, setModalVisibilidadeTransferir] = useState(false);
    const [modalVisibilidadeNovaTarefa, setModalVisibilidadeNovaTarefa] = useState(false);
    const [modalVisibilidadeAceitar, setModalVisibilidadeAceitar] = useState(false);
    const [modalVisibilidadeIniciar, setModalVisibilidadeIniciar] = useState(false);
    const [modalVisibilidadeCancelar, setModalVisibilidadeCancelar] = useState(false);
    const [modalVisibilidadeDRL, setModalVisibilidadeDRL] = useState(false);
    const [modalVisibilidadeConfiguracoes, setModalVisibilidadeConfiguracoes] = useState(false);
    const [modalVisibilidadePriorizacao, setModalVisibilidadePriorizacao] = useState(false);
    const [modalVisibilidadeExportar, setModalVisibilidadeExportar] = useState(false);
    const [modalVisibilidadeMensagens, setModalVisibilidadeMensagens] = useState(false);
    const [isTarefaModal, setIsTarefaModal] = useState(false);
    const [modalVisibilidadeRenovar, setModalVisibilidadeRenovar] = useState(false);
    const [selectedProcessoModal, setSelectedProcessoModal] = useState([]);

    const toggleTodosProcessos = { name: 'toggleTodosProcessos', label: 'Todos os Processos', id: 'toggleTodosProcessos', status: todosProcessosChecked, checked: todosProcessosChecked };
    const toggleTodaMinhaArea = { name: 'toggleTodaMinhaArea', label: 'Todas as Áreas', id: 'toggleTodaMinhaArea', status: todaMinhaAreaChecked, checked: todaMinhaAreaChecked, disabled: !todosProcessosChecked ? "disabled" : "" };
    const toggleProcessosEmAndamento = { name: 'toggleProcessosEmAndamento', label: 'Processos Encerrados', id: 'toggleProcessosEmAndamento', status: processosEmAndamentoChecked, checked: processosEmAndamentoChecked };
    const toggleTabela = { name: 'toggleTabela', label: legendaTableView, id: 'toggleTabela', status: tabelaChecked, checked: tabelaChecked, disabled: "disabled" };
    const togglePesquisaAvancada = { name: 'togglePesquisaAvancada', label: 'Pesquisa Avançada', id: 'togglePesquisaAvancada', status: pesquisaAvancadaChecked, checked: pesquisaAvancadaChecked };
    const toggleHistorico = { name: 'toggleHistorico', label: 'Histórico', id: 'toggleHistorico', status: historicoChecked, checked: historicoChecked };
    const toggleCronometro = { name: 'toggleCronometro', label: 'Cronômetro Ativo', id: 'toggleCronometro', status: cronometroChecked, checked: cronometroChecked };
    const toggleSemLiderResponsavel = { name: 'toggleSemLiderResponsavel', label: 'Sem Líder / Responsável', id: 'toggleSemLiderResponsavel', status: semLiderResponsavelChecked, checked: semLiderResponsavelChecked };

    const [urlFiltros, setUrlFiltros] = useState('');
    const getListaVisibilidade = async (formValues = null, currentPage = 0, pageSize) => {
        let params = `Start=${currentPage}&Length=${pageSize ?? 300}`;

        const statusTodosProcessos = formValues?.todosProcessos ?? todosProcessosChecked;
        params += `&TodosProcessos=${statusTodosProcessos}`;

        if (formValues?.search && formValues?.search?.length > 0) {
            params += `&Search=${formValues.search}`;
        }

        if (formValues?.todasAreas) {
            params += `&TodasAreas=${formValues?.todasAreas}`;
        }

        if (formValues?.processosEncerrados) {
            params += `&ProcessosEncerrados=${formValues?.processosEncerrados}`;
        }

        if (formValues?.cronometroAtivo) {
            params += `&CronometroAtivo=${formValues?.cronometroAtivo}`;
        }

        if (formValues?.sinalizadores?.length > 0) {
            formValues?.sinalizadores.forEach(sinalizador => {
                params += `&Sinalizadores=${sinalizador}`;
            });
        }

        if (formValues?.macroEtapas?.length > 0) {
            formValues?.macroEtapas.forEach(macroEtapa => {
                params += `&MacroEtapas=${macroEtapa}`;
            });
        }

        if (formValues?.jornadas?.length > 0) {
            formValues?.jornadas.forEach(jornada => {
                params += `&Jornadas=${jornada}`;
            });
        }

        //Busca Avançada
        if (formValues?.data?.Sigla && formValues?.data?.Sigla.length > 0) {
            params += `&Sigla=${formValues.data.Sigla}`;
        }

        if (formValues?.idTipoCronometro && formValues?.idTipoCronometro > 0) {
            params += `&IdTipoCronometro=${formValues.idTipoCronometro}`;
        }

        if (formValues?.idDocumentacaoPendente && formValues?.idDocumentacaoPendente > 0) {
            params += `&IdDocumentacaoPendente=${formValues.idDocumentacaoPendente}`;
        }

        if (formValues?.idStatusCronometro && formValues?.idStatusCronometro > 0) {
            params += `&idStatusCronometro=${formValues.idStatusCronometro}`;
        }

        if (formValues?.idJornada) {
            params += `&IdJornada=${formValues.idJornada}`;
        }

        if (formValues?.idEtapa) {
            params += `&IdEtapa=${formValues.idEtapa}`;
        }

        if (formValues?.idMacroEtapa) {
            params += `&IdMacroEtapa=${formValues.idMacroEtapa}`;
        }

        if (formValues?.idStatusTarefa?.length > 0) {
            formValues.idStatusTarefa.forEach(id => {
                params += `&StatusTarefaIds=${id}`;
            });
        }

        if (formValues?.idCliente && formValues?.idCliente > 0) {
            params += `&IdCliente=${formValues.idCliente}`;
        }

        if (formValues?.data?.Segurado && formValues?.data?.Segurado?.length > 0) {
            params += `&Segurado=${formValues.data.Segurado}`;
        }

        if (formValues?.data?.EnderecoSinistro && formValues?.data?.EnderecoSinistro?.length > 0) {
            params += `&EnderecoSinistro=${formValues.data.EnderecoSinistro}`;
        }

        if (formValues?.idDisciplinas?.length > 0) {
            formValues?.idDisciplinas.forEach(disciplina => {
                params += `&Disciplinas=${disciplina}`;
            });
        }

        if (formValues?.idPeritos?.length > 0) {
            formValues?.idPeritos.forEach(idPerito => {
                params += `&Profissionais=${idPerito}`;
            });
        }

        if (formValues?.idTipoSinistro && formValues?.idTipoSinistro > 0) {
            params += `&IdTipoSinistro=${formValues.idTipoSinistro}`;
        }

        if (formValues?.idPorteSinistro && formValues?.idPorteSinistro > 0) {
            params += `&IdPorteSinistro=${formValues.idPorteSinistro}`;
        }

        if (formValues?.idBase && formValues?.idBase > 0) {
            params += `&IdBase=${formValues.idBase}`;
        }

        if (formValues?.idClassificacaoShortLong && formValues?.idClassificacaoShortLong > 0) {
            params += `&IdClassificacaoShortLong=${formValues.idClassificacaoShortLong}`;
        }

        if (formValues?.idClassificacaoDFIFast && formValues?.idClassificacaoDFIFast > 0) {
            params += `&IdClassificacaoDFIFast=${formValues.idClassificacaoDFIFast}`;
        }

        if (formValues?.idDepartamento?.length > 0) {
            formValues.idDepartamento.forEach(id => {
                params += `&DepartamentosIds=${id}`;
            });
        }

        if (formValues?.idEscopo?.length > 0) {
            formValues.idEscopo.forEach(id => {
                params += `&EscoposIds=${id}`;
            });
        }

        if (formValues?.idStatusProcesso && formValues?.idStatusProcesso > 0) {
            params += `&IdStatusProcesso=${formValues.idStatusProcesso}`;
        }

        if (formValues?.semLiderResponsavel) {
            params += `&SemLiderResponsavel=${formValues?.semLiderResponsavel}`;
        }

        if (moment(formValues?.startDate).isValid() && formValues?.startDate) {
            params += `&DataInicioProcesso=${moment(formValues.startDate).format('YYYY-MM-DD')}`;
        }

        if (moment(formValues?.endDate).isValid() && formValues?.endDate) {
            params += `&DataFimProcesso=${moment(formValues.endDate).format('YYYY-MM-DD')}`;
        }

        setUrlFiltros(params);
        setLoadingData(true);
        const rstData = await requestGetListaVisibilidade(params);
        setLoadingData(false);
        return rstData;
    }

    const formSubmit = async (data, meusProcessosParam = false) => {
        formData(data, 0, 300, meusProcessosParam);
    }

    const formData = async (data, currentPage, pageSize, meusProcessosParam = false) => {
        let formValues = {
            data: data,
            todosProcessos: todosProcessosChecked,
            search: searchInput?.length >= 3 ? searchInput : null,
            todasAreas: todaMinhaAreaChecked,
            processosEncerrados: processosEmAndamentoChecked,
            cronometroAtivo: cronometroChecked,
            sinalizadores: sinalizadores,
            macroEtapas: macroEtapaIds,
            jornadas: jornadas,

            idTipoCronometro: idTipoCronometro,
            idStatusCronometro: idStatusCronometro,
            idDocumentacaoPendente: idDocumentacaoPendente,
            idJornada: idJornada,
            idEtapa: idEtapa,
            idMacroEtapa: idMacroEtapa,
            idStatusTarefa: pesquisaAvancadaChecked ? idStatusTarefa : null,
            idCliente: idCliente,
            idDisciplinas: idDisciplinas,
            idPeritos: idPeritos,
            idTipoSinistro: idTipoSinistro,
            idPorteSinistro: idPorteSinistro,
            idBase: baseId,
            idDepartamento: idDepartamento,
            idEscopo: idEscopo,
            idClassificacaoShortLong: classificacaoLongShortId,
            idClassificacaoDFIFast: classificacaoDFIFastId,
            idStatusProcesso: idStatusProcesso,
            semLiderResponsavel: semLiderResponsavelChecked,
            startDate: startDate,
            endDate: endDate
        };
        setVisibilidadeData(null);

        try {
            const Visibilidade = await getListaVisibilidade(formValues, currentPage, pageSize);

            if (Visibilidade?.data && Visibilidade?.data?.itens?.length > 0) {
                setVisibilidadeData(Visibilidade);
                setProcessoList(Visibilidade.data);
            }
            setFiltersCount(Visibilidade?.data?.page?.filterCounts);
            setFilterCountsSub(Visibilidade?.data?.page?.filterCountsSub);
        } catch (error) {
            console.log(error);
        } finally { }
    }

    // --- FUNÇÃO PARA EXPORTAR ---
    const handleExportarRelatorio = async (parametrosDoModal = {}) => {

        const dataForm = getValues();
        let formValues = {
            data: dataForm,
            todosProcessos: todosProcessosChecked,
            search: searchInput?.length >= 3 ? searchInput : null,
            todasAreas: todaMinhaAreaChecked,
            processosEncerrados: processosEmAndamentoChecked,
            cronometroAtivo: cronometroChecked,
            sinalizadores: sinalizadores,
            macroEtapas: macroEtapaIds,
            jornadas: jornadaIds,

            segurado: dataForm.Segurado,
            enderecoSinistro: dataForm.EnderecoSinistro,
            sigla: dataForm.Sigla,
            idTipoCronometro: idTipoCronometro,
            idStatusCronometro: idStatusCronometro,
            idDocumentacaoPendente: idDocumentacaoPendente,
            idJornada: idJornada,
            idEtapa: idEtapa,
            idMacroEtapa: idMacroEtapa,
            idStatusTarefa: idStatusTarefa,
            idCliente: idCliente,
            disciplinas: idDisciplinas,
            profissionais: idPeritos,
            idTipoSinistro: idTipoSinistro,
            idPorteSinistro: idPorteSinistro,
            idBase: baseId,
            departamentosIds: idDepartamento,
            escoposIds: idEscopo,
            idClassificacaoShortLong: classificacaoLongShortId,
            idClassificacaoDFIFast: classificacaoDFIFastId,
            idStatusProcesso: idStatusProcesso,
            semLiderResponsavel: semLiderResponsavelChecked,
            dataInicioProcesso: startDate,
            dataFimProcesso: endDate,

            // Mescla parâmetros futuros do modal
            ...parametrosDoModal
        };

        try {
            const response = await api.post(`Visibilidade/list/exportar`, formValues, {
                responseType: 'blob'
            });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;

            const contentDisposition = response.headers['content-disposition'];
            let fileName = `Relatorio_Visibilidade_${moment().format('DDMMYYYY')}.xlsx`;

            if (contentDisposition) {
                const fileNameMatch = contentDisposition.match(/filename="?([^";]+)"?/);
                if (fileNameMatch && fileNameMatch.length === 2) {
                    fileName = fileNameMatch[1];
                }
            }

            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();

            link.remove();
            window.URL.revokeObjectURL(url);

            return true;

        } catch (error) {
            console.error("Erro ao exportar", error);
            throw error;
        }
    }

    const refreshData = async (isNull = false) => {
        let data = {
            Sigla: null,
            Segurado: null,
            EnderecoSinistro: null
        }

        let formValues = {
            data: data,
            todosProcessos: toggleTodosProcessos,
            search: searchInput?.length >= 3 ? searchInput : null,
            todasAreas: todaMinhaAreaChecked,
            processosEncerrados: processosEmAndamentoChecked,
            cronometroAtivo: cronometroChecked,
            sinalizadores: sinalizadores,
            macroEtapas: macroEtapaIds,
            jornadas: jornadaIds,

            idTipoCronometro: idTipoCronometro,
            idStatusCronometro: idStatusCronometro,
            idDocumentacaoPendente: idDocumentacaoPendente,
            idJornada: idJornada,
            idEtapa: idEtapa,
            idMacroEtapa: idMacroEtapa,
            idStatusTarefa: idStatusTarefa,
            idCliente: idCliente,
            idDisciplinas: idDisciplinas,
            idPeritos: idPeritos,
            idTipoSinistro: idTipoSinistro,
            idPorteSinistro: idPorteSinistro,
            idBase: baseId,
            idDepartamento: idDepartamento,
            idEscopo: idEscopo,
            idClassificacaoShortLong: classificacaoLongShortId,
            idClassificacaoDFIFast: classificacaoDFIFastId,
            idStatusProcesso: idStatusProcesso,
            semLiderResponsavel: semLiderResponsavelChecked,
            startDate: startDate,
            endDate: endDate
        };

        if (isNull) {
            for (const key in formValues) {
                if (Object.hasOwnProperty.call(formValues, key)) {
                    formValues[key] = null;

                }
            }
            formValues.idEmpresa = idEmpresa;
        }

        setPageSize(pageSize);
        setVisibilidadeData(null);

        try {
            const _visibilidade = await getListaVisibilidade(formValues, currentPage, pageSize);

            if (_visibilidade.data.itens.length > 0) {
                setVisibilidadeData(_visibilidade);
                pageSize = _visibilidade.length;
                setFiltersCount(_visibilidade.data.page.filterCounts);
                setFilterCountsSub(_visibilidade.data.page.filterCountsSub);
            }

            setTimeout(() => {
                //
            }, 1000);

        } catch (error) {
            console.log(error);
        }
    }

    const getSemLiderResponsavel = (status) => {
        setSemLiderResponsavelChecked(status => !status);
    }

    const getTodosProcessos = (status) => {
        setTodaMinhaAreaChecked(false);
        setTodosProcessosChecked(status => !status);
    };

    const getTodaMinhaArea = (status) => {
        setTodaMinhaAreaChecked(status => !status);
    };

    const getProcessosEmAndamento = (status) => {
        setProcessosEmAndamentoChecked(status => !status);
    };

    const getTabela = (status) => {
        const legendaTableView = !status ? 'Tabela' : 'Cards';
        setTabelaChecked(status => !status);
        setLegendaTableView(legendaTableView);
    };

    const getPesquisaAvancada = (status) => {
        setPesquisaAvancadaChecked(status => !status);
    };

    const getCronometro = (status) => {
        setCronometroChecked(status => !status);
    };

    const getTarefas = async (idProcesso, idTipoServico, isHistorico) => {
        const _headers = { 'Content-Type': 'application/json' };
        const _dados = {
            idProcesso: parseInt(idProcesso),
            idTipoServico: idTipoServico,
            isHistorico: isHistorico
        };
        const resultTarefa = await api.get(`Visibilidade/tarefa`, {
            params: _dados,
            headers: _headers
        });

        let listaTarefas = resultTarefa.data.data || [];

        // Se for histórico, aplica a ordenação
        if (isHistorico) {
            listaTarefas.sort((a, b) => {
                // Tarefas sem dataConclusao (pendentes) recebem um valor "infinito" para ficarem no topo
                // Tarefas com data são convertidas para timestamp
                const dateA = a.dataConclusao ? new Date(a.dataConclusao).getTime() : 8640000000000000;
                const dateB = b.dataConclusao ? new Date(b.dataConclusao).getTime() : 8640000000000000;

                // Ordenação decrescente (Maior data/Futuro -> Menor data/Passado)
                return dateB - dateA;
            });
        }

        setTarefasPorProcesso(prevState => ({
            ...prevState,
            [idProcesso]: listaTarefas
        }));
    };

    const getHistorico = async (status, idProcesso, idTipoServico) => {
        const isAtivo = historicoAtivoPorProcesso.includes(idProcesso);
        const novoStatus = !isAtivo;

        setHistoricoAtivoPorProcesso(prev => {
            if (isAtivo) {
                return prev.filter(id => id !== idProcesso);
            } else {
                return [...prev, idProcesso];
            }
        });

        await getTarefas(idProcesso, idTipoServico, novoStatus);
    };

    const handleDetalheClick = async (idProcesso, idTipoServico) => {

        const estaAberto = itensExpandidos.includes(idProcesso);

        if (estaAberto) {
            setItensExpandidos(prev => prev.filter(id => id !== idProcesso));

            setTarefasPorProcesso(prev => {
                const copia = { ...prev };
                delete copia[idProcesso];
                return copia;
            });

        } else {
            setItensExpandidos(prev => [...prev, idProcesso]);

            try {
                const _headers = { 'Content-Type': 'application/json' };
                const _dados = {
                    idProcesso: parseInt(idProcesso),
                    idTipoServico: idTipoServico,
                    isHistorico: false
                };

                console.log(_dados);

                const resultTarefa = await api.get(`Visibilidade/tarefa`, {
                    params: _dados,
                    headers: _headers
                });

                setTarefasPorProcesso(prevState => ({
                    ...prevState,
                    [idProcesso]: resultTarefa.data.data
                }));

            } catch (error) {
                console.error("Erro ao buscar tarefas", error);
            }
        }
    };

    const handleStartDateChange = (date) => {
        setStartDate(date);
    }

    const handleEndDateChange = (date) => {
        setEndtDate(date);
    }

    const getSearch = async (currentValue, value, pageSize = 300, forceidEmpresa = false) => {
        searchInput = (currentValue >= 3) ? currentValue : null;
        setSearchInput(currentValue);

        try {
            let data = {
                Sigla: null,
                Segurado: null,
                EnderecoSinistro: null
            }

            let formValues = {
                data: data,
                todosProcessos: null,
                search: currentValue?.length >= 3 ? currentValue : null,
                todasAreas: todaMinhaAreaChecked,
                processosEncerrados: null,
                cronometroAtivo: null,
                sinalizadores: null,
                macroEtapas: null,
                jornadas: null,

                idTipoCronometro: null,
                idStatusCronometro: null,
                idDocumentacaoPendente: null,
                idJornada: null,
                idEtapa: null,
                idMacroEtapa: null,
                idStatusTarefa: null,
                idCliente: null,
                idDisciplinas: null,
                idPeritos: null,
                idTipoSinistro: null,
                idPorteSinistro: null,
                idBase: null,
                idDepartamento: null,
                idEscopo: null,
                idClassificacaoShortLong: null,
                idClassificacaoDFIFast: null,
                idStatusProcesso: null,
                semLiderResponsavel: null,
                startDate: null,
                endDate: null
            };

            setPageSize(pageSize);
            const _visibilidade = await getListaVisibilidade(formValues, currentPage, pageSize);
            setVisibilidadeData(null);

            if (_visibilidade?.data?.itens && _visibilidade?.data?.itens?.length > 0) {
                setVisibilidadeData(_visibilidade);
                pageSize = _visibilidade.length;
            }

            setFiltersCount(_visibilidade.data.page.filterCounts);
            setFilterCountsSub(_visibilidade.data.page.filterCountsSub);
        } catch (e) { } finally { }

    };

    const setDefaultFilters = () => {
        let data = {
            Sigla: null,
        };

        setDefaultSetted(data)
    }

    const handleNext = () => {
        if (currentIndex < maxSteps) {
            setCurrentIndex(currentIndex + 1);
        }
    };

    const handlePrev = () => {
        if (currentIndex > 0) {
            setCurrentIndex(currentIndex - 1);
        }
    };

    function truncateText(text, maxLength) {
        if (text.length <= maxLength) {
            return text;
        }
        return text.substring(0, maxLength) + "...";
    }

    //==== Multiselect Jornadas ====//
    const handleMultiselectChange = async (selectedList) => {
        const novosIds = selectedList.map(item => item.idJornada);

        setJornadas(novosIds);
        setJornadaIds(novosIds);

        // Pega os valores atuais do formulário (caso tenha busca avançada preenchida)
        const currentData = getValues();

        const formValuesAtualizados = {
            data: currentData,

            // Garante que o estado atual dos filtros principais seja mantido
            todosProcessos: todosProcessosChecked,
            todasAreas: todaMinhaAreaChecked, // <--- AQUI ESTAVA O PROBLEMA (antes não era passado)
            processosEncerrados: processosEmAndamentoChecked,
            cronometroAtivo: cronometroChecked,
            search: searchInput?.length >= 3 ? searchInput : null,

            // Listas
            sinalizadores: sinalizadores,
            macroEtapas: macroEtapaIds,
            jornadas: novosIds,  // O novo valor das jornadas

            // Mantém os filtros da busca avançada
            idTipoCronometro: idTipoCronometro,
            idStatusCronometro: idStatusCronometro,
            idDocumentacaoPendente: idDocumentacaoPendente,
            idJornada: idJornada,
            idEtapa: idEtapa,
            idMacroEtapa: idMacroEtapa,
            idStatusTarefa: pesquisaAvancadaChecked ? idStatusTarefa : null,
            idCliente: idCliente,
            idDisciplinas: idDisciplinas,
            idPeritos: idPeritos,
            idTipoSinistro: idTipoSinistro,
            idPorteSinistro: idPorteSinistro,
            idBase: baseId,
            idDepartamento: idDepartamento,
            idEscopo: idEscopo,
            idClassificacaoShortLong: classificacaoLongShortId,
            idClassificacaoDFIFast: classificacaoDFIFastId,
            idStatusProcesso: idStatusProcesso,
            semLiderResponsavel: semLiderResponsavelChecked,
            startDate: startDate,
            endDate: endDate
        };

        setLoadingData(true);

        try {
            const response = await getListaVisibilidade(formValuesAtualizados);
            if (response?.data && response?.data?.itens?.length > 0) {
                setVisibilidadeData(response);
                setProcessoList(response.data);
            } else {
                setVisibilidadeData(null);
                setProcessoList([]);
            }

            setFiltersCount(response?.data?.page?.filterCounts);
            setFilterCountsSub(response?.data?.page?.filterCountsSub);

        } catch (error) {
            console.error("Erro ao filtrar jornadas:", error);
        } finally {
            setLoadingData(false);
        }
    };

    //==== Busca Avançada ====//
    const getEtapa = (currentValue, value) => {
        if (!value) {
            setEtapa(null);
            setIdEtapa(null);
            return;
        }

        var etapaResult = etapasList.filter(function (o) {
            return o.idEtapa == value;
        });
        etapa = etapaResult[0].nomeEtapa;
        idEtapa = etapaResult[0].idEtapa;
        setEtapa(etapa);
        setIdEtapa(idEtapa);
    };

    const getMacroEtapa = (currentValue, value) => {
        if (!value) {
            setMacroEtapa(null);
            setIdMacroEtapa(null);
            return;
        }

        var macroEtapaResult = macroEtapasList.filter(function (o) {
            return o.idMacroEtapa == value;
        });
        macroEtapa = macroEtapaResult[0].nomeMacroEtapa;
        idMacroEtapa = macroEtapaResult[0].idMacroEtapa;
        setMacroEtapa(macroEtapa);
        setIdMacroEtapa(idMacroEtapa);
    };

    const getJornada = (currentValue, value) => {
        if (!value) {
            setJornada(null);
            setIdJornada(null);
            return;
        }

        var jornadaResult = jornadasList.filter(function (o) {
            return o.idJornada == value;
        });
        jornada = jornadaResult[0].nomeJornada;
        idJornada = jornadaResult[0].idJornada;
        setJornada(jornada);
        setIdJornada(idJornada);
    };

    const handleSinalizadorClick = (id) => {
        if (!id) return;

        const jaExiste = sinalizadores.includes(id);
        let novaLista;

        if (jaExiste) {
            novaLista = sinalizadores.filter(item => item !== id);
        } else {
            novaLista = [...sinalizadores, id];
        }

        setSinalizadores(novaLista);
    };

    const handleMacroEtapaClicks = (idClicado) => {
        setMacroEtapaIds((idsAnteriores) => {
            const jaExiste = idsAnteriores.includes(idClicado);
            let novaListaIds;

            if (jaExiste) {
                novaListaIds = idsAnteriores.filter(id => id !== idClicado);
            } else {
                novaListaIds = [...idsAnteriores, idClicado];
            }
            return novaListaIds;
        });
    };

    const handleStatusTarefaChange = (selectedList) => {
        setSelectedStatusTarefa(selectedList);
        const ids = selectedList.map(item => item.key);
        setIdStatusTarefa(ids);
    };

    const getStatusTarefa = (currentValue, value) => {
        if (!value) {
            setStatusTarefa(null);
            setIdStatusTarefa(null);
            return;
        }

        var statusTarefaResult = statusTarefaType.filter(function (o) {
            return o.key == value;
        });
        statusTarefa = statusTarefaResult[0].value;
        idStatusTarefa = statusTarefaResult[0].key;
        setStatusTarefa(statusTarefa);
        setIdStatusTarefa(idStatusTarefa);
    };

    const getTipoCronometo = (currentValue, value) => {
        if (!value) {
            setTipoCronometro(null);
            setIdTipoCronometro(null);
            return;
        }

        var tipoCronometroResult = tipoCronometroType.filter(function (o) {
            return o.key == value;
        });
        tipoCronometro = tipoCronometroResult[0].value;
        idTipoCronometro = tipoCronometroResult[0].key;
        setTipoCronometro(tipoCronometro);
        setIdTipoCronometro(idTipoCronometro);
    };

    const getTipoSinistro = (currentValue, value) => {
        if (!value) {
            setTipoSinistro(null);
            setIdTipoSinistro(null);
            return;
        }

        var tipoSinistroResult = tipoSinistroType.filter(function (o) {
            return o.idTipoSinistro == value;
        });
        tipoSinistro = tipoSinistroResult[0].nome;
        idTipoSinistro = tipoSinistroResult[0].idTipoSinistro;
        setTipoSinistro(tipoSinistro);
        setIdTipoSinistro(idTipoSinistro);
    };

    const getPorteSinistro = (currentValue, value) => {
        if (!value) {
            setPorteSinistro(null);
            setIdPorteSinistro(null);
            return;
        }

        var porteSinistroResult = porteSinistroType.filter(function (o) {
            return o.key == value;
        });
        porteSinistro = porteSinistroResult[0].value;
        idPorteSinistro = porteSinistroResult[0].key;
        setPorteSinistro(porteSinistro);
        setIdPorteSinistro(idPorteSinistro);
    };

    const getStatusProcesso = (currentValue, value) => {
        if (!value) {
            setStatusProcesso(null);
            setIdStatusProcesso(null);
            return;
        }

        var statusProcessoResult = statusProcessoType.filter(function (o) {
            return o.key == value;
        });
        statusProcesso = statusProcessoResult[0].value;
        idStatusProcesso = statusProcessoResult[0].key;
        setStatusProcesso(statusProcesso);
        setIdStatusProcesso(idStatusProcesso);
    };

    const getDocumentacaoPendente = (currentValue, value) => {
        if (!value) {
            setDocumentacaoPendente(null);
            setIdDocumentacaoPendente(null);
            return;
        }

        var documentacaoPendenteResult = documentacaoPendenteType.filter(function (o) {
            return o.key == value;
        });
        documentacaoPendente = documentacaoPendenteResult[0].value;
        idDocumentacaoPendente = documentacaoPendenteResult[0].key;
        setDocumentacaoPendente(documentacaoPendente);
        setIdDocumentacaoPendente(idDocumentacaoPendente);
    }

    const getCronometo = (currentValue, value) => {
        if (!value) {
            setCronometro(null);
            setIdStatusCronometro([]);
            return;
        }

        var cronometroResult = cronometroType.filter(function (o) {
            return o.key == value;
        });
        cronometro = cronometroResult[0].value;
        idStatusCronometro = cronometroResult[0].key;
        setCronometro(cronometro);
        setIdStatusCronometro(idStatusCronometro);
    }

    const getCliente = (currentValue, value) => {
        if (!value) {
            setCliente(null);
            setIdCliente([]);
            return;
        }

        var clienteResult = clientList.filter(function (o) {
            return o.idCliente == value;
        });
        cliente = clienteResult[0].cliente;
        idCliente = clienteResult[0].idCliente;
        setCliente(cliente);
        setIdCliente(idCliente);
    };

    const onGetDisciplina = (currentValue, value) => {
        let disciplinasList = [];

        disciplina = value.titulo;
        setDisciplina(disciplina);

        currentValue.map(a => { disciplinasList.push(a.idDisciplina) });
        idDisciplinas = disciplinasList;

        setDisciplinasId(disciplinasList);
    };

    const onRemoveDisciplina = (currentValue, value) => {
        let disciplinasList = [];

        currentValue.map(a => { disciplinasList.push(a.idDisciplina) });
        idDisciplinas = disciplinasList;

        setDisciplinasId(disciplinasList);
    }

    const onGetPerito = (currentValue, value) => {
        let peritosList = [];

        perito = value.nome;
        setPerito(perito);

        currentValue.map(a => { peritosList.push(a.idUsuario) });
        idPeritos = peritosList;

        setPeritosId(peritosList);
    };

    const onRemovePerito = (currentValue, value) => {
        let peritosList = [];

        currentValue.map(a => { peritosList.push(a.idUsuario) });
        idPeritos = peritosList;

        setPeritosId(peritosList);
    }

    var [base, setBase] = useState(null);
    var [baseId, setBaseId] = useState(null);
    const [bases, setBases] = useState([]);
    const [basesList, setBasesList] = useState([]);

    var [idDepartamento, setIdDepartamento] = useState([]);
    var [departamentos, setDepartamentos] = useState([]);
    const [departamentosList, setDepartamentosList] = useState([]);

    var [idEscopo, setIdEscopo] = useState([]);
    var [escopos, setEscopos] = useState([]);
    const [escoposList, setEscoposList] = useState([]);

    var [classificacaoLongShort, setClassificacaoLongShort] = useState(null);
    var [classificacaoLongShortId, setClassificacaoLongShortId] = useState(null);
    const [classificacaoLongShortList, setClassificacaoLongShortList] = useState([]);

    var [classificacaoDFIFast, setClassificacaoDFIFast] = useState(null);
    var [classificacaoDFIFastId, setClassificacaoDFIFastId] = useState(null);
    const [classificacaoDFIFastList, setClassificacaoDFIFastList] = useState([]);   
    

    const getBase = (currentValue, value) => {
        if (!value) {
            setBase(null);
            setBaseId(null);
            return;
        }

        var baseResult = basesList.filter(function (o) {
            return o.key == value;
        });
        base = baseResult[0].value;
        baseId = baseResult[0].key;
        setBase(base);
        setBaseId(baseId);
    };

    const handleDepartamentoChange = (selectedList) => {
        setDepartamentos(selectedList);
        const ids = selectedList.map(item => item.idDepartamento);
        setIdDepartamento(ids);
    };

    const handleEscopoChange = (selectedList) => {
        setEscopos(selectedList);
        const ids = selectedList.map(item => item.key);
        setIdEscopo(ids);
    };

    const getClassificacaoLongShort = (currentValue, value) => {
        if (!value) {
            setClassificacaoLongShort(null);
            setClassificacaoLongShortId(null);
            return;
        }

        var classificacaoLongShortResult = classificacaoLongShortList.filter(function (o) {
            return o.key == value;
        });

        classificacaoLongShort = classificacaoLongShortResult[0].value;
        classificacaoLongShortId = classificacaoLongShortResult[0].key;
        setClassificacaoLongShort(classificacaoLongShort);
        setClassificacaoLongShortId(classificacaoLongShortId);
    }

    const getClassificacaoDFIFast = (currentValue, value) => {
        if (!value) {
            setClassificacaoDFIFast(null);
            setClassificacaoDFIFastId(null);
            return;
        }

        var classificacaoDFIFastResult = classificacaoDFIFastList.filter(function (o) {
            return o.key == value;
        });

        classificacaoDFIFast = classificacaoDFIFastResult[0].value;
        classificacaoDFIFastId = classificacaoDFIFastResult[0].key;
        setClassificacaoDFIFast(classificacaoDFIFast);
        setClassificacaoDFIFastId(classificacaoDFIFastId);
    }

    const resetFormAvancado = async () => {
        history.replace(`visibilidade`);
        reset({
            Sigla: '',
            Segurado: '',
            EnderecoSinistro: ''
        });

        setValue('Segurado', '');
        setValue('Sigla', '');
        setValue('EnderecoSinistro', '');

        tipoCronometro = null;
        idTipoCronometro = null;
        setTipoCronometro(null);
        setIdTipoCronometro(null);

        documentacaoPendente = null;
        idDocumentacaoPendente = null;
        setDocumentacaoPendente(null);
        setIdDocumentacaoPendente(null);

        cronometro = null;
        idStatusCronometro = null;
        setCronometro(null);
        setIdStatusCronometro(null);

        jornada = null;
        idJornada = null;
        setJornada(null);
        setIdJornada(null);

        etapa = null;
        idEtapa = null;
        setEtapa(null);
        setIdEtapa(null);

        macroEtapa = null;
        idMacroEtapa = null;
        setMacroEtapa(null);
        setIdMacroEtapa(null);

        statusTarefa = null;
        idStatusTarefa = null;
        const idsPadraoTarefa = [1, 2, 3];
        const defaultsTarefa = statusTarefaType.filter(item => idsPadraoTarefa.includes(item.key));
        setStatusTarefa(null);
        setIdStatusTarefa(idsPadraoTarefa);
        setSelectedStatusTarefa(defaultsTarefa);

        cliente = null;
        idCliente = null;
        setCliente(null);
        setIdCliente(null);

        disciplina = null;
        idDisciplinas = null;
        setDisciplinasId(null);
        setDisciplinaDefaultValue(null);

        perito = null;
        idPeritos = null;
        setPeritosId(null);
        setPeritosListDefaultValue(null);

        tipoSinistro = null;
        idTipoSinistro = null;
        setTipoSinistro(null);
        setIdTipoSinistro(null);

        porteSinistro = null;
        idPorteSinistro = null;
        setPorteSinistro(null);
        setIdPorteSinistro(null);

        baseId = null;
        base = null;
        setBase(null);
        setBaseId(null);

        departamentos = null;
        idDepartamento = null;
        setDepartamentos(null);
        setIdDepartamento(idsPadraoTarefa);

        classificacaoLongShort = null;
        classificacaoLongShortId = null;
        setClassificacaoLongShort(null);
        setClassificacaoLongShortId(null);

        classificacaoDFIFast = null;
        classificacaoDFIFastId = null;
        setClassificacaoDFIFast(null);
        setClassificacaoDFIFastId(null);

        statusProcesso = null;
        idStatusProcesso = null;
        setStatusProcesso(null);
        setIdStatusProcesso(null);

        setSemLiderResponsavelChecked(false);

        setStartDate(null);
        setEndtDate(null);

        multiselectRef.current.resetSelectedValues();

        const cleanFormValues = {
            data: {
                Sigla: null,
                Segurado: null,
                EnderecoSinistro: null
            },
            todosProcessos: todosProcessosChecked,
            search: null,
            todasAreas: todaMinhaAreaChecked,
            processosEncerrados: false,
            cronometroAtivo: false,
            sinalizadores: [],
            macroEtapas: [],
            jornadas: [],
            idDisciplinas: [],
            idPeritos: [],
            idTipoCronometro: null,
            idStatusCronometro: null,
            idDocumentacaoPendente: null,
            idJornada: null,
            idEtapa: null,
            idMacroEtapa: null,
            idStatusTarefa: null,
            idCliente: null,
            idTipoSinistro: null,
            idPorteSinistro: null,
            idBase: null,
            idDepartamento: null,
            idClassificacaoShortLong: null,
            idClassificacaoDFIFast: null,
            idStatusProcesso: null,
            semLiderResponsavel: false,
            startDate: null,
            endDate: null
        };

        setPageSize(300);
        try {
            setLoadingData(true);
            const result = await getListaVisibilidade(cleanFormValues, 0, 300);
            if (result?.data) {
                setVisibilidadeData(result);
                setProcessoList(result.data);
                setFiltersCount(result.data.page?.filterCounts);
                setFilterCountsSub(result.data.page?.filterCountsSub);
            } else {
                setVisibilidadeData(null);
                setProcessoList([]);
                setFiltersCount([]);
                setFilterCountsSub([]);
            }
        } catch (err) {
            console.error('Erro ao resetar filtros e buscar lista', err);
        } finally {
            setLoadingData(false);
        }
    };

    const handleRefreshGrid = async (idProcessoAtualizado = null, idTipoServico = null) => {
        setLoadingData(true);
        setVisibilidadeData(null);
        const currentData = getValues();

        await formData(currentData, currentPage, pageSize);

        if (idProcessoAtualizado && idTipoServico && itensExpandidos.includes(idProcessoAtualizado)) {
            const isHistorico = historicoAtivoPorProcesso.includes(idProcessoAtualizado);
            await getTarefas(idProcessoAtualizado, idTipoServico, isHistorico);
        }
    };

    //#region === Modais ====//

    const openModalVisibilidadeNovaTarefa = (idProcesso, laudo) => {
        setModalIdProcesso(idProcesso);
        setSelectedProcessoLaudo(laudo);
        setModalVisibilidadeNovaTarefa(true);
    }

    const closeModalVisibilidadeNovaTarefa = (currentValue, value) => {
        setModalIdProcesso(null);
        setModalVisibilidadeNovaTarefa(false);
    }

    const openModalVisibilidadeIniciar = (processo, laudo) => {
        setSelectedProcessoModal(processo);
        setSelectedProcessoLaudo(laudo);
        setModalVisibilidadeIniciar(true);
    }

    const closeModalVisibilidadeIniciar = (currentValue, value) => {
        setSelectedProcessoModal([]);
        setModalVisibilidadeIniciar(false);
    }

    const openModalVisibilidadeRenovar = (processo, laudo) => {
        setSelectedProcessoModal(processo);
        setSelectedProcessoLaudo(laudo);
        setModalVisibilidadeRenovar(true);
    }

    const closeModalVisibilidadeRenovar = (currentValue, value) => {
        setSelectedProcessoModal([]);
        setModalVisibilidadeRenovar(false);
    }

    const openModalVisibilidadeAceitar = (processo, laudo) => {
        setSelectedProcessoModal(processo);
        setSelectedProcessoLaudo(laudo);
        setModalVisibilidadeAceitar(true);
    }

    const closeModalVisibilidadeAceitar = (currentValue, value) => {
        setSelectedProcessoModal([]);
        setModalVisibilidadeAceitar(false);
    }

    const openModalVisibilidadeAcoes = (processo, laudo) => {
        setSelectedProcesso(processo);
        setSelectedProcessoLaudo(laudo);
        setModalVisibilidadeAcoes(true);
    }

    const closeModalVisibilidadeAcoes = (currentValue, value) => { setModalVisibilidadeAcoes(false); }

    const openModalVisibilidadeCancelar = (processo, laudo) => {
        setSelectedProcessoModal(processo);
        setSelectedProcessoLaudo(laudo);
        setModalVisibilidadeCancelar(true);
    }

    const closeModalVisibilidadeCancelar = (currentValue, value) => {
        setSelectedProcessoModal([]);
        setModalVisibilidadeCancelar(false);
    }

    const openModalVisibilidadeDRL = (processo, laudo) => {
        setSelectedProcessoModal(processo);
        setSelectedProcessoLaudo(laudo);
        setModalVisibilidadeDRL(true);
    }

    const closeModalVisibilidadeDRL = (currentValue, value) => {
        setSelectedProcessoModal([]);
        setModalVisibilidadeDRL(false);
    }

    const openModalVisibilidadeConfiguracoes = (processo, laudo) => {
        setSelectedProcessoModal(processo);
        setSelectedProcessoLaudo(laudo);
        setModalVisibilidadeConfiguracoes(true);
    }

    const closeModalVisibilidadeConfiguracoes = (currentValue, value) => {
        setSelectedProcessoModal([]);
        setModalVisibilidadeConfiguracoes(false);
    }

    const openModalVisibilidadeTransferir = (processo, laudo) => {
        setSelectedProcessoModal(processo);
        setSelectedProcessoLaudo(laudo);
        setModalVisibilidadeTransferir(true);
    }

    const closeModalVisibilidadeTransferir = (currentValue, value) => { setModalVisibilidadeTransferir(false); }

    const openModalVisibilidadePriorizacao = () => {
        setModalVisibilidadePriorizacao(true);
    }

    const closeModalVisibilidadePriorizacao = (currentValue, value) => { setModalVisibilidadePriorizacao(false); }

    const openModalVisibilidadeExportar = () => { setModalVisibilidadeExportar(true); }
    const closeModalVisibilidadeExportar = (currentValue, value) => { setModalVisibilidadeExportar(false); }

    const openModalVisibilidadeMensagens = (tarefa, laudo, isTarefa) => {
        setSelectedProcessoModal(laudo);
        setSelectedProcessoLaudo(laudo);
        setSelectedTarefa(tarefa);
        setIsTarefaModal(isTarefa);
        setModalVisibilidadeMensagens(true);
    }
    const closeModalVisibilidadeMensagens = (currentValue, value) => { setModalVisibilidadeMensagens(false); }
    //#endregion ==== Modais ====// //==== Ações Tarefa ====//

    useEffect(() => {
        if (trackRef.current && totalItems > 0) {
            const track = trackRef.current;
            const items = track.children;

            if (items.length > 0) {
                const itemWidth = items[0].offsetWidth;
                const newTransformValue = -currentIndex * itemWidth;

                track.style.transform = `translateX(${newTransformValue}px)`;
            }
        }
    }, [currentIndex, macroEtapasList, totalItems]);

    const [readyToFetch, setReadyToFetch] = useState(false);
    useEffect(() => {
        history.replace('visibilidade');
        Promise.all([
            getVisibilidadeJornadas(),
            getVisibilidadeEtapas(),
            getVisibilidadeMacroEtapas(),
            getOptionAllVisibilidade(),
            getClients(),
            getDisciplinas(),
            getPeritos(),
            getGeneriList(51),
            getGeneriList(52),
            getSinisterTypes(),
            getGeneriList(21),
            getGeneriList(4),
            getGeneriList(53),
            getGeneriList(54),
            getGeneriList(55),

            getGeneriList(59),
            getGeneriList(60),
            getGeneriList(61),
            getGeneriList(62),
            getDepartamentTypes(1)
        ]).then((dataResponse) => {

            setJornadasList(dataResponse[0]);
            setEtapasList(dataResponse[1]);
            setMacroEtapasList(dataResponse[2]);
            setVisibilidadeAllOptions(dataResponse[3]);
            setClientList(dataResponse[4]);
            setDisciplinaList(dataResponse[5]);
            setPeritosList(dataResponse[6]);
            setStatusTarefaType(dataResponse[7]);
            setTipoCronometroType(dataResponse[8]);
            setTipoSinistroType(dataResponse[9]);
            setPorteSinistroType(dataResponse[10]);
            setStatusProcessoType(dataResponse[11]);
            setTipoPrioridadeType(dataResponse[12]);
            setCoberturaStatusType(dataResponse[13]);
            setStatusDocumentacao(dataResponse[14]);

            setBasesList(dataResponse[15]);
            setEscoposList(dataResponse[16]);
            setClassificacaoLongShortList(dataResponse[17]);
            setClassificacaoDFIFastList(dataResponse[18]);
            setDepartamentosList(dataResponse[19]);

            setDocumentacaoPendenteType(opcoesDocumentosPendentes);
            setCronometroType(opcoesCronometro);
            setDefaultFilters();


            const initialTodosProcessos = dataResponse[3]?.todosProcessos || false;
            const initialTodasAreas = dataResponse[3]?.todasAreas || false;

            setTodosProcessosChecked(initialTodosProcessos);
            setTodaMinhaAreaChecked(initialTodasAreas);

            setReadyToFetch(true);
        });
    }, []);

    useEffect(() => {
        if (!readyToFetch) {
            return;
        }
        formData({}, 0, 300);

    }, [
        readyToFetch,
        todaMinhaAreaChecked,
        processosEmAndamentoChecked,
        cronometroChecked,
        sinalizadores,
        macroEtapaIds,
        todosProcessosChecked
    ]);

    useEffect(() => {
        if (statusTarefaType && statusTarefaType.length > 0 && selectedStatusTarefa.length === 0) {

            const idsParaMarcar = [1, 2, 3];
            const defaults = statusTarefaType.filter(item => idsParaMarcar.includes(item.key));

            if (defaults.length > 0) {
                setSelectedStatusTarefa(defaults);
                setIdStatusTarefa(defaults.map(i => i.key));
            }
        }
    }, [statusTarefaType]);

    useEffect(() => {
        formData(getValues(), 0, pageSize);
    }, [pesquisaAvancadaChecked]);

    const opcoesDocumentosPendentes = [
        { key: "all", value: 'Todos' },
        { key: 1, value: 'Sim' },
        { key: 2, value: 'Não' },
    ];

    const opcoesCronometro = [
        { key: "all", value: 'Todos' },
        { key: 1, value: 'Ativo' },
        { key: 2, value: 'Pausado' },
        { key: 3, value: 'Concluído' },
    ];

    const COR_SINALIZADORES = {
        0: "",
        1: "#10B981",
        2: "#f7cc4d",
        3: "#f16262",
        4: "#aa0505",
    };

    return (
        <section>
            <main className="d-flex">
                {(() => {
                    if (isDesktop) {
                        return (
                            <Menu></Menu>
                        )
                    }
                    return null
                })()}
                <StyledVisibillidadePage style={{ overflowX: 'hidden', width: '100%' }}>
                    <div className="w-100 d-flex justify-content-between align-items-center">
                        <div className="title-row">
                            <h5 className="title-row-header m-0">Visibilidade</h5>
                            <span title="Atualizar" className="cursorPointer" onClick={refreshData}><IconRefresh color={"#EE4B21"} /></span>
                        </div>
                        <div className="">
                            {visibilidadeAllOptions?.priorizar ? (<><input className='default-button-red mr-1' value='Priorização' type="button" onClick={() => openModalVisibilidadePriorizacao()} /></>) : ''}
                            {visibilidadeAllOptions?.exportarRelatorio ? (<><input className='default-button-red ' value='Exportar' type="button" onClick={() => openModalVisibilidadeExportar()} /></>) : ''}
                        </div>
                    </div>
                    <div className="card m-0 p-0 py-3 mt-2">
                        <div className="row m-0 p-0">
                            <div className="form-container d-flex flex-column justify-content-center col-sm-12 col-md-6 col-lg-6 col-xxl-6">
                                <div className="row m-0">
                                    <div className="form-container d-flex flex-column justify-content-center col-sm-12 col-md-4 col-lg-4 col-xxl-4">
                                        <ToggleSwitchFilters config={toggleTodosProcessos} setStatus={(status) => getTodosProcessos(status)} />
                                    </div>
                                    <div className="form-container d-flex flex-column justify-content-center col-sm-12 col-md-4 col-lg-4 col-xxl-4">
                                        <ToggleSwitchFilters config={toggleTodaMinhaArea} setStatus={(status) => getTodaMinhaArea(status)} />
                                    </div>
                                    <div className="form-container d-flex flex-column justify-content-center col-sm-12 col-md-4 col-lg-4 col-xxl-4">
                                        <ToggleSwitchFilters config={toggleProcessosEmAndamento} setStatus={(status) => getProcessosEmAndamento(status)} />
                                    </div>
                                </div>
                                <div className="row m-0 mt-3">
                                    <div className="form-container d-flex flex-column justify-content-center col-sm-12 col-md-4 col-lg-4 col-xxl-4">
                                        <ToggleSwitchFilters config={toggleTabela} setStatus={(status) => getTabela(status)} />
                                    </div>
                                    <div className="form-container d-flex flex-column justify-content-center col-sm-12 col-md-4 col-lg-4 col-xxl-4">
                                        <DynamicInput type={'text'} placeholder={''} componentReadOnly={searchReadOnly} label={'Pesquisar'} name={'Search'} paramMethod={getSearch} value={searchInput} />
                                    </div>
                                    <div className="form-container d-flex flex-column justify-content-center col-sm-12 col-md-4 col-lg-4 col-xxl-4">
                                        <ToggleSwitchFilters config={togglePesquisaAvancada} setStatus={(status) => getPesquisaAvancada(status)} />
                                    </div>
                                </div>
                            </div>
                            <div className="d-flex flex-column justify-content-center col-sm-12 col-md-5 col-lg-6 col-xxl-6 p-0">
                                <div className="row py-2">
                                    <div className="pull-left d-flex flex-column justify-content-center col-sm-12 col-md-4 col-lg-4 col-xxl-4">
                                        <div className="mb-3">
                                            <ToggleSwitchFilters config={toggleCronometro} setStatus={(status) => getCronometro(status)} />
                                        </div>
                                        <Multiselect
                                            ref={multiselectRef}
                                            className="searchWrapperCustom"
                                            placeholder={'Jornadas'}
                                            showCheckbox="true"
                                            options={jornadasList}
                                            onSelect={handleMultiselectChange}
                                            onRemove={handleMultiselectChange}
                                            displayValue="nomeJornada"
                                            selectedValues={jornadasList.filter(jornada => idJornadas.includes(jornada.idJornadas))}
                                            showArrow={true}
                                        />
                                    </div>
                                    <div className="pull-right d-flex flex-column justify-content-center col-sm-12 col-md-8 col-lg-8 col-xxl-8">
                                        <div className="circles-container pl-4">
                                            <div className={`progress-circle p-3 cursorPointer ${sinalizadores.includes(processoList.alertas?.[0]?.idTipoSinalizacaoPrazo) ? 'selecionado' : ''}`} style={{ "--p": processoList.alertas?.[0]?.porcentagem || 0, "--c": "#10B981" }} onClick={() => handleSinalizadorClick(processoList.alertas?.[0]?.idTipoSinalizacaoPrazo)}>
                                                <span className="progress-value">{processoList.alertas?.[0]?.porcentagem || 0}%</span>
                                                <span style={{ fontSize: "12px", zIndex: 1 }}>No Prazo</span>
                                                <span className={'badge bg-primary color-text-filter filter-NoPrazo'} style={{ zIndex: 1 }} key="v_badge_1">{processoList.alertas?.[0]?.quantidade || 0}</span>
                                            </div>

                                            <div className={`progress-circle p-3 cursorPointer ${sinalizadores.includes(processoList.alertas?.[1]?.idTipoSinalizacaoPrazo) ? 'selecionado' : ''}`} style={{ "--p": processoList.alertas?.[1]?.porcentagem || 0, "--c": "#f7cc4d" }} onClick={() => handleSinalizadorClick(processoList.alertas?.[1]?.idTipoSinalizacaoPrazo)}>
                                                <span className="progress-value">{processoList.alertas?.[1]?.porcentagem || 0}%</span>
                                                <span style={{ fontSize: "12px", zIndex: 1 }}>Em Alerta</span>
                                                <span className={'badge bg-primary color-text-filter filter-Notificado'} style={{ zIndex: 1 }} key="v_badge_2">{processoList.alertas?.[1]?.quantidade || 0}</span>
                                            </div>

                                            <div className={`progress-circle p-3 cursorPointer ${sinalizadores.includes(processoList.alertas?.[2]?.idTipoSinalizacaoPrazo) ? 'selecionado' : ''}`} style={{ "--p": processoList.alertas?.[2]?.porcentagem || 0, "--c": "#f16262" }} onClick={() => handleSinalizadorClick(processoList.alertas?.[2]?.idTipoSinalizacaoPrazo)}>
                                                <span className="progress-value">{processoList.alertas?.[2]?.porcentagem || 0}%</span>
                                                <span style={{ fontSize: "12px", zIndex: 1 }}>No Limite</span>
                                                <span className={'badge bg-primary color-text-filter filter-NoLimite'} style={{ zIndex: 1 }} key="v_badge_4">{processoList.alertas?.[2]?.quantidade || 0}</span>
                                            </div>

                                            <div className={`progress-circle p-3 cursorPointer ${sinalizadores.includes(processoList.alertas?.[3]?.idTipoSinalizacaoPrazo) ? 'selecionado' : ''}`} style={{ "--p": processoList.alertas?.[3]?.porcentagem || 0, "--c": "#aa0505" }} onClick={() => handleSinalizadorClick(processoList.alertas?.[3]?.idTipoSinalizacaoPrazo)}>
                                                <span className="progress-value">{processoList.alertas?.[3]?.porcentagem || 0}%</span>
                                                <span style={{ fontSize: "12px", zIndex: 1 }}>Expirado</span>
                                                <span className={'badge bg-primary color-text-filter filter-Reprovado'} style={{ zIndex: 1 }} key="v_badge_3">{processoList.alertas?.[3]?.quantidade || 0}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <StyledForm onSubmit={handleSubmit(formSubmit)}>
                            {pesquisaAvancadaChecked && (
                                <div className="row d-none d-sm-block px-2 pb-2 mt-2">
                                    <div className="row m-0 mt-3">
                                        <div className="col-12">
                                            <b>Pesquisa Avançada</b>
                                        </div>
                                    </div>
                                    <div className="row m-0 mt-3">
                                        <div className="form-container d-flex flex-column justify-content-center col-sm-12 col-md-3 col-lg-3 col-xxl-3">
                                            <DynamicInput type={'text'} placeholder={''} label={'Sigla'} name={'Sigla'} register={register} />
                                        </div>
                                        <div className="form-container d-flex flex-column justify-content-center col-sm-12 col-md-3 col-lg-3 col-xxl-3">
                                            <DynamicSelect placeholder={''} valuetext={tipoCronometro} label={'Tipo Cronômetro'} name={'idTipoCronometro'} options={tipoCronometroType} keyValue={'key'} keyLabel={'value'} clearOption={true} paramMethod={getTipoCronometo} />
                                        </div>
                                        <div className="form-container d-flex flex-column justify-content-center col-sm-12 col-md-3 col-lg-3 col-xxl-3">
                                            <DynamicSelect placeholder={''} valuetext={documentacaoPendente} label={'Documentação Pendente'} name={'idDocumentacaoPendente'} options={documentacaoPendenteType} keyValue={'key'} keyLabel={'value'} clearOption={true} paramMethod={getDocumentacaoPendente} />
                                        </div>
                                        <div className="form-container d-flex flex-column justify-content-center col-sm-12 col-md-3 col-lg-3 col-xxl-3">
                                            <DynamicSelect placeholder={''} valuetext={cronometro} label={'Cronômetro'} name={'idStatusCronometro'} options={cronometroType} keyValue={'key'} keyLabel={'value'} clearOption={true} paramMethod={getCronometo} />
                                        </div>
                                    </div>

                                    <div className="row m-0 mt-3">
                                        <div className="form-container d-flex flex-column justify-content-center col-sm-12 col-md-3 col-lg-3 col-xxl-3">
                                            <DynamicSelect placeholder={''} valuetext={jornada} label={'Jornada'} name={'idJornada'} options={jornadasList} keyValue={'idJornada'} keyLabel={'nomeJornada'} clearOption={true} paramMethod={getJornada} />
                                        </div>
                                        <div className="form-container d-flex flex-column justify-content-center col-sm-12 col-md-3 col-lg-3 col-xxl-3">
                                            <DynamicSelect placeholder={''} valuetext={etapa} label={'Etapa'} name={'idEtapa'} options={etapasList} keyValue={'idEtapa'} keyLabel={'nomeEtapa'} clearOption={true} paramMethod={getEtapa} />
                                        </div>
                                        <div className="form-container d-flex flex-column justify-content-center col-sm-12 col-md-3 col-lg-3 col-xxl-3">
                                            <DynamicSelect placeholder={''} valuetext={macroEtapa} label={'Macro Etapa'} name={'idMacroEtapa'} options={macroEtapasList} keyValue={'idMacroEtapa'} keyLabel={'nomeMacroEtapa'} clearOption={true} paramMethod={getMacroEtapa} />
                                        </div>
                                        <div className="form-container d-flex flex-column justify-content-center col-sm-12 col-md-3 col-lg-3 col-xxl-3">
                                            <Multiselect
                                                className="searchWrapperCustom"
                                                placeholder={'Status da Tarefa'}
                                                options={statusTarefaType}     // Lista de opções
                                                selectedValues={selectedStatusTarefa} // State visual (objetos completos)
                                                onSelect={handleStatusTarefaChange}   // Função ao marcar
                                                onRemove={handleStatusTarefaChange}   // Função ao desmarcar
                                                displayValue="value"           // Nome do campo para exibir (baseado no seu keyLabel original)
                                                showCheckbox={true}            // Habilita checkboxes e o "Selecionar Todos"
                                                showArrow={true}
                                                isObject={true}
                                                ref={multiselectRef}           // Opcional, para reset via ref se necessário
                                            />
                                        </div>
                                    </div>

                                    <div className="row m-0 mt-3">
                                        <div className="form-container d-flex flex-column justify-content-center col-sm-12 col-md-3 col-lg-3 col-xxl-3">
                                            <DynamicSelect placeholder={''} valuetext={cliente} label={'Cliente'} name={'idCliente'} options={clientList} keyValue={'idCliente'} keyLabel={'cliente'} clearOption={true} paramMethod={getCliente} />
                                        </div>
                                        <div className="form-container d-flex flex-column justify-content-center col-sm-12 col-md-3 col-lg-3 col-xxl-3">
                                            <DynamicInput type={'text'} placeholder={''} label={'Segurado'} name={'Segurado'} register={register} />
                                        </div>
                                        <div className="form-container d-flex flex-column justify-content-center col-sm-12 col-md-3 col-lg-3 col-xxl-3">
                                            <DynamicInput type={'text'} placeholder={''} label={'End. Sinistro'} name={'EnderecoSinistro'} register={register} />
                                        </div>
                                        <div className="form-container d-flex flex-column justify-content-center col-sm-12 col-md-3 col-lg-3 col-xxl-3">
                                            <Multiselect
                                                className="searchWrapperCustom"
                                                placeholder={'Selecione a disciplina'}
                                                showCheckbox="true"
                                                options={disciplinaList}
                                                selectedValues={disciplinaDefaultValue}
                                                onSelect={onGetDisciplina}
                                                onRemove={onRemoveDisciplina}
                                                displayValue="titulo"
                                                ref={multiselectRef}
                                                showArrow={true}
                                            />
                                        </div>
                                    </div>                                    

                                    <div className="row m-0 mt-3">
                                        <div className="form-container d-flex flex-column justify-content-center col-sm-12 col-md-3 col-lg-3 col-xxl-3">
                                            <Multiselect
                                                className="searchWrapperCustom"
                                                placeholder={'Profissionais'}
                                                showCheckbox="true"
                                                options={peritosList} 
                                                selectedValues={peritosListDefaultValue} 
                                                onSelect={onGetPerito} 
                                                onRemove={onRemovePerito} 
                                                displayValue="nome" 
                                                ref={multiselectRef}
                                                showArrow={true}
                                                disable={semLiderResponsavelChecked}
                                            />
                                        </div>
                                        <div className="form-container d-flex flex-column justify-content-center col-sm-12 col-md-3 col-lg-3 col-xxl-3">
                                            <DynamicSelect placeholder={''} valuetext={tipoSinistro} label={'Tipo Sinistro'} name={'idTipoSinistro'} options={tipoSinistroType} keyValue={'idTipoSinistro'} keyLabel={'nome'} clearOption={true} paramMethod={getTipoSinistro} />
                                        </div>
                                        <div className="form-container d-flex flex-column justify-content-center col-sm-12 col-md-3 col-lg-3 col-xxl-3">
                                            <DynamicSelect placeholder={''} valuetext={porteSinistro} label={'Porte Sinistro'} name={'idPorteSinistro'} options={porteSinistroType} keyValue={'key'} keyLabel={'value'} clearOption={true} paramMethod={getPorteSinistro} />
                                        </div>
                                        <div className="form-container d-flex flex-column justify-content-center col-sm-12 col-md-3 col-lg-3 col-xxl-3">
                                            <DynamicSelect placeholder={''} valuetext={statusProcesso} label={'Status do Processo'} name={'idStatusProcesso'} options={statusProcessoType} keyValue={'key'} keyLabel={'value'} clearOption={true} paramMethod={getStatusProcesso} />
                                        </div>
                                    </div>

                                    <div className="row m-0 mt-3">
                                        <div className="form-container d-flex flex-column justify-content-center col-sm-12 col-md-3 col-lg-3 col-xxl-3">
                                            <DynamicSelect placeholder={''} valuetext={base} label={'Base'} name={'idBase'} options={basesList} keyValue={'key'} keyLabel={'value'} clearOption={true} paramMethod={getBase} />
                                        </div>
                                        <div className="form-container d-flex flex-column justify-content-center col-sm-12 col-md-3 col-lg-3 col-xxl-3">
                                            <Multiselect
                                                className="searchWrapperCustom"
                                                placeholder={'Departamento'}
                                                options={departamentosList}
                                                onSelect={handleDepartamentoChange}
                                                onRemove={handleDepartamentoChange}
                                                displayValue="nome"
                                                showCheckbox={true}
                                                showArrow={true}
                                                isObject={true}
                                                ref={multiselectRef}
                                            />
                                        </div>
                                        <div className="form-container d-flex flex-column justify-content-center col-sm-12 col-md-3 col-lg-3 col-xxl-3">
                                            <Multiselect
                                                className="searchWrapperCustom"
                                                placeholder={'Escopo'}
                                                options={escoposList}
                                                onSelect={handleEscopoChange}
                                                onRemove={handleEscopoChange}
                                                displayValue="value"
                                                showCheckbox={true}
                                                showArrow={true}
                                                isObject={true}
                                                ref={multiselectRef}
                                            />
                                        </div>
                                        <div className="form-container d-flex flex-column justify-content-center col-sm-12 col-md-3 col-lg-3 col-xxl-3">
                                            <DynamicSelect placeholder={''} valuetext={classificacaoLongShort} label={'Classificação Short/Long'} name={'idClassificacaoLongShort'} options={classificacaoLongShortList} keyValue={'key'} keyLabel={'value'} clearOption={true} paramMethod={getClassificacaoLongShort} />
                                        </div>
                                        
                                    </div>

                                    <div className="row m-0 mt-3">
                                        <div className="form-container d-flex flex-column justify-content-center col-sm-12 col-md-3 col-lg-3 col-xxl-3">
                                            <DynamicSelect placeholder={''} valuetext={classificacaoDFIFast} label={'Classificação DFI/Fast'} name={'idClassificacaoDFIFast'} options={classificacaoDFIFastList} keyValue={'key'} keyLabel={'value'} clearOption={true} paramMethod={getClassificacaoDFIFast} />
                                        </div>

                                        <div className="form-container d-flex flex-column justify-content-center col-sm-12 col-md-3 col-lg-3 col-xxl-3">
                                            <DatePicker
                                                dateFormat="dd/MM/yyyy"
                                                locale="pt-BR"
                                                className="input-form"
                                                selected={startDate}
                                                onChange={handleStartDateChange}
                                                placeholderText={'Data Início Processo'}
                                            />
                                        </div>
                                        <div className="form-container d-flex flex-column justify-content-center col-sm-12 col-md-3 col-lg-3 col-xxl-3">
                                            <DatePicker
                                                dateFormat="dd/MM/yyyy"
                                                locale="pt-BR"
                                                className="input-form"
                                                selected={endDate}
                                                onChange={handleEndDateChange}
                                                placeholderText={'Data Final Processo'}
                                            />
                                        </div>
                                        <div className="form-container d-flex flex-column justify-content-center col-sm-12 col-md-3 col-lg-3 col-xxl-3">
                                            <ToggleSwitchFilters config={toggleSemLiderResponsavel} setStatus={(status) => getSemLiderResponsavel(status)} />
                                        </div>
                                    </div>

                                    <div className="row m-0 mt-3">
                                        <div className="col-12">
                                            <input type="submit" className='default-button-red mr-2' value='Pesquisar' ref={submitButtonPesquisaAvanca} />
                                            <input className='default-button' value='Limpar' type="button" onClick={resetFormAvancado} />
                                        </div>
                                    </div>

                                </div>
                            )}
                        </StyledForm>

                        <div className="row d-none d-sm-block px-4 pb-2 mt-2">
                            <div className="slider-container">
                                <div className="slider-viewport">
                                    <div className="slider-track" ref={trackRef}>
                                        {processoList.macroEtapas && processoList.macroEtapas.map((etapa) => (
                                            <div className="slide-item" key={etapa.idMacroEtapa + "_slide"}>
                                                <input
                                                    type="checkbox"
                                                    name="filterCheckIndicadoresEtapas"
                                                    className="btn-check d-flex"
                                                    id={"input_macroEtapas_" + etapa.idMacroEtapa}
                                                    value={etapa.idMacroEtapa}
                                                    key={etapa.idMacroEtapa}
                                                    onChange={() => handleMacroEtapaClicks(etapa.idMacroEtapa)}
                                                    checked={macroEtapaIds.includes(etapa.idMacroEtapa)}
                                                />
                                                <label
                                                    className="btn btn-sm btn-light mb-0 w-100"
                                                    htmlFor={"input_macroEtapas_" + etapa.idMacroEtapa}
                                                    key={"input_macroEtapas_" + etapa.idMacroEtapa}
                                                >
                                                    <span className="text-max-10">{etapa.legendaMacroEtapa}</span><br />
                                                    <span className={'badge bg-primary'}>{etapa.quantidade}</span>
                                                </label >
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <button type="button" id="prevBtn" className="nav-btn prev-btn" onClick={handlePrev} disabled={currentIndex === 0}><span title="Back" className=""><IconArrowAngleLeft /></span></button>
                                <button type="button" id="nextBtn" className="nav-btn next-btn" onClick={handleNext} disabled={currentIndex >= maxSteps}><span title="Next" className=""><IconArrowAngleRight /></span></button>
                            </div>
                        </div>
                    </div>

                    <div className="card">
                        {
                            loadingData ?
                                <div className="text-center mb-2">
                                    <div className="d-flex align-items-center">
                                        <div className="spinner-border mr-2" style={{ color: "#EE4B21" }} role="status" aria-hidden="true"></div>
                                        <strong style={{ color: "#EE4B21" }}>Aguarde enquanto carregamos as informações</strong>
                                    </div>
                                </div>
                                : ''}

                        {VisibilidadeData?.data?.itens ? (
                            <div className="mb-2">
                                <div className="w-100" role="group" key={"visibilidade_itens_group_main"}>
                                    <table className="table align-middle m-0" style={{ fontSize: "12px" }}>
                                        <thead style={{ border: "none" }}>
                                            <tr style={{
                                                border: `1px solid #ccc`,
                                                borderTop: `0.1rem solid #ccc`,
                                                borderLeft: `0.4rem solid #ccc`
                                            }}>
                                                <th className="text-center" style={{ borderBottom: "none" }}>Ações</th>
                                                <th className="text-center" style={{ borderBottom: "none" }}>Laudo</th>
                                                <th className="text-center" style={{ borderBottom: "none" }}>Líder</th>
                                                <th className="text-center" style={{ borderBottom: "none" }}>Cliente</th>
                                                <th className="text-center" style={{ borderBottom: "none" }}>Segurado</th>
                                                <th className="text-center" style={{ borderBottom: "none" }}>Status</th>
                                                <th style={{ borderBottom: "none" }}></th>
                                                <th className="text-center" style={{ borderBottom: "none" }}>Lei Geral<br /> (Reg.)</th>
                                                <th className="text-center" style={{ borderBottom: "none" }}>Lei Geral<br /> (Liq.)</th>
                                                {/* <th className="text-center" style={{borderBottom: "none"}}>Prazo<br /> Análise</th> */}
                                                <th className="text-center" style={{ borderBottom: "none" }}>Tempo<br /> de Vida</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {VisibilidadeData?.data?.itens?.map((item) => (
                                                <React.Fragment key={item.idProcesso + "_fragment"}>
                                                    <tr key={item.idProcesso + "_processo"} style={{
                                                        borderLeft: `0.4rem solid ${COR_SINALIZADORES[item.tipoSinalizacao.idTipoSinalizacao]}`,
                                                        borderRight: `0.1rem solid #ccc`
                                                    }}>
                                                        <td className="text-center px-0">
                                                            <div className="row m-0 p-0 mt-1" key={item.idProcesso + "_acoes"}>
                                                                <div className="col p-0 m-0">
                                                                    <span
                                                                        data-tooltip={itensExpandidos.includes(item.idProcesso) ? "Ocultar Atividades" : "Exibir Atividades"}
                                                                        className="cursorPointer has-tooltip"
                                                                        onClick={() => handleDetalheClick(item.idProcesso, item.idTipoServico)}
                                                                    >
                                                                        {itensExpandidos.includes(item.idProcesso) ? (
                                                                            <IconCaretUp color={"#acaaaa"} />
                                                                        ) : (
                                                                            <IconCaretDown color={"#acaaaa"} />
                                                                        )}
                                                                    </span>
                                                                </div>
                                                                <div className="col p-0 m-0"><span title="" data-tooltip="Configurações" className="cursorPointer has-tooltip" onClick={() => openModalVisibilidadeConfiguracoes(item, item)}><IconGear color={"#acaaaa"} /></span></div>
                                                                <div className="col p-0 m-0"><span title="" data-tooltip="Mensagens do Processo" className="cursorPointer has-tooltip" onClick={() => openModalVisibilidadeMensagens([], item, false)}><IconComments color={"#acaaaa"} /></span></div>
                                                                {/*
                                                                <div className="col p-0 m-0"><span title="" data-tooltip="DRL" className="cursorPointer has-tooltip opacity-30"><IconDocFile color={"#acaaaa"} /></span></div>
                                                                <div className="col p-0 m-0"><span title="" data-tooltip="DRL" className="cursorPointer has-tooltip" onClick={() => openModalVisibilidadeDRL(item, item)}><IconDocFile color={"#acaaaa"} /></span></div>
                                                                */}
                                                            </div>
                                                        </td>
                                                        <td className="text-center align-middle">{item.processoSigla}</td>
                                                        <td className="align-middle">{item.liderProcesso}</td>
                                                        <td data-tooltip={item.cliente} className="has-tooltip align-middle">{truncateText(item.cliente, 20)}</td>
                                                        <td data-tooltip={item.segurado} className="has-tooltip align-middle">{truncateText(item.segurado, 12)}</td>
                                                        <td className="text-center align-middle">{item.statusProcesso}</td>
                                                        <td className="p-0 align-middle">
                                                            <TimelineVisibilidade key={`timeline_${item.idProcesso}`} statuses={item.timeline} stepAtual={0} />
                                                        </td>
                                                        <td className="text-center align-middle bold font-td-size-13">
                                                            {(() => {
                                                                const valor = item.leiGeralRegulacaoCausa;

                                                                if (valor === null || valor === undefined || valor === '') {
                                                                    return <span>-</span>;
                                                                }

                                                                if (valor === 0 || valor === "0") {
                                                                    return <span>0</span>;
                                                                }

                                                                return (
                                                                    <div style={{
                                                                        display: 'inline-flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center',
                                                                        width: '25px',
                                                                        height: '25px',
                                                                        borderRadius: '50%',
                                                                        backgroundColor: '#EE4B21',
                                                                        color: '#FFF',
                                                                        fontWeight: '900',
                                                                        fontSize: '15px',
                                                                        margin: '0 auto'
                                                                    }}>
                                                                        {valor}
                                                                    </div>
                                                                );
                                                            })()}
                                                        </td>
                                                        <td className="text-center align-middle bold font-td-size-13">{item.leiGeralRegulacaoLiquidacao != null ? item.leiGeralRegulacaoLiquidacao : "-"}</td>
                                                        <td className="text-center align-middle bold font-td-size-13">{item.tempoDeVida != null ? item.tempoDeVida : "-"}</td>
                                                    </tr>
                                                    {itensExpandidos.includes(item.idProcesso) && (
                                                        <tr className="p-0" key={item.idProcesso + "_detalhe"}>
                                                            <td colSpan="11" className="p-0">
                                                                <table className="table align-middle m-0" style={{ fontSize: "12px" }}>
                                                                    <thead>
                                                                        <tr className="" style={{
                                                                            backgroundColor: '#f1f1f1',
                                                                            border: `1px solid #666666`,
                                                                            borderTop: `0.1rem solid #666666`,
                                                                            borderLeft: `0.2rem solid #666666`
                                                                        }}>

                                                                            <td className="pe-0">
                                                                                <span data-tooltip="Nova Tarefa" className="cursorPointer has-tooltip" onClick={() => openModalVisibilidadeNovaTarefa(item.idProcesso, item)}><IconFileCirclePlus color={"#999"} /></span>
                                                                            </td>
                                                                            <td className="pe-0">
                                                                                {(() => {
                                                                                    const isHistoryOn = historicoAtivoPorProcesso.includes(item.idProcesso);

                                                                                    const dynamicToggleConfig = {
                                                                                        name: `toggleHistorico_${item.idProcesso}`,
                                                                                        label: 'Histórico',
                                                                                        id: `toggleHistorico_${item.idProcesso}`,
                                                                                        status: isHistoryOn,
                                                                                        checked: isHistoryOn
                                                                                    };

                                                                                    return (
                                                                                        <ToggleSwitchFilters
                                                                                            key={`toggleHistorico_${item.idProcesso}`}
                                                                                            config={dynamicToggleConfig}
                                                                                            setStatus={(status) => getHistorico(status, item.idProcesso, item.idTipoServico)}
                                                                                        />
                                                                                    );
                                                                                })()}
                                                                            </td>
                                                                            <td className="text-center">Data Criação</td>
                                                                            <td className="text-center">Etapa</td>
                                                                            <td className="text-center">Responsável</td>
                                                                            <td className="text-center">Data Prazo</td>
                                                                            <td className="text-center">SLA</td>
                                                                            <td className="text-center">SLA Real</td>
                                                                            <td className="text-center">Data Conclusão</td>
                                                                            <td className="text-center">Sinalizador</td>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {tarefasPorProcesso[item.idProcesso]?.map((itemTarefa, index) => (
                                                                            <React.Fragment key={itemTarefa.idTarefa ?? itemTarefa.id ?? `${item.idProcesso}_tarefa_${index}`}>
                                                                                <tr key={"tarefaTr_" + itemTarefa?.idProcesso} className="py-0" style={{
                                                                                    border: `1px solid #666666`,
                                                                                    borderTop: `0.1rem solid #666666`,
                                                                                    borderLeft: `0.2rem solid #666666`
                                                                                }}>
                                                                                    <td className="text-center ps-4" colSpan={2}>
                                                                                        <div className="row align-items-center m-0 p-0 mt-1" key={item.idProcesso + "_acoesTarefa"}>
                                                                                            {itemTarefa.actions.acao && (<> <div className="col-1 p-0 m-0 me-2 cursorPointer" onClick={() => openModalVisibilidadeAcoes(itemTarefa, item)}><span data-tooltip="Ações" className="cursorPointer has-tooltip" title=""><IconBoltLightning color={"#acaaaa"} /></span></div> </>)}
                                                                                            {itemTarefa.actions.renovar && (<> <div className="col-1 p-0 m-0 me-2 cursorPointer" onClick={() => openModalVisibilidadeRenovar(itemTarefa, item)}><span data-tooltip="Renovar Tarefa" className="cursorPointer has-tooltip" title=""><IconClockRotateLeft color={"#acaaaa"} /></span></div> </>)}
                                                                                            <div className="col-1 p-0 m-0 me-2 cursorPointer"><span onClick={() => openModalVisibilidadeMensagens(itemTarefa, item, true)} data-tooltip="Mensagens da Tarefa" className="cursorPointer has-tooltip"><IconComments color={"#acaaaa"} /></span></div>
                                                                                            {itemTarefa.actions.iniciar && (<> <div className="col-1 p-0 m-0 me-2 cursorPointer" onClick={() => openModalVisibilidadeIniciar(itemTarefa, item)}><span data-tooltip="Iniciar Tarefa" className="cursorPointer has-tooltip" title=""><IconPlay color={"#acaaaa"} /></span></div> </>)}
                                                                                            {itemTarefa.actions.aceitar && (<> <div className="col-1 p-0 m-0 me-2 cursorPointer" onClick={() => openModalVisibilidadeAceitar(itemTarefa, item)}><span data-tooltip="Aceitar Tarefa" className="cursorPointer has-tooltip" title=""><IconCheckToSlot color={"#acaaaa"} /></span></div> </>)}
                                                                                            {itemTarefa.actions.transferir && (<> <div className="col-1 p-0 m-0 me-2 cursorPointer" onClick={() => openModalVisibilidadeTransferir(itemTarefa, item)}><span data-tooltip="Transferir Tarefa" className="cursorPointer has-tooltip" title=""><IconArrowRightArrowLeft color={"#acaaaa"} /></span></div> </>)}
                                                                                            {itemTarefa.actions.cancelar && (<> <div className="col-1 p-0 m-0 me-2 cursorPointer" onClick={() => openModalVisibilidadeCancelar(itemTarefa, item)}><span data-tooltip="Cancelar Tarefa" className="cursorPointer has-tooltip" title=""><IconBan color={"#acaaaa"} /></span></div> </>)}
                                                                                        </div>
                                                                                    </td>
                                                                                    <td className="text-center">{new Date(itemTarefa.dataCriacao).toLocaleDateString('pt-BR')}</td>
                                                                                    <td className="text-center">{itemTarefa.nomeEtapa}</td>
                                                                                    <td className="text-center">{itemTarefa.nomeUsuarioResponsavel}</td>
                                                                                    <td className="text-center">{new Date(itemTarefa.dataPrazo).toLocaleDateString('pt-BR')}</td>
                                                                                    <td className="text-center">{itemTarefa.sla}</td>
                                                                                    <td className="text-center">{itemTarefa.slaReal}</td>
                                                                                    <td className="text-center">{itemTarefa.dataConclusao == "" ? "" : new Date(itemTarefa.dataConclusao).toLocaleDateString('pt-BR')}</td>

                                                                                    <td className="text-center">
                                                                                        {itemTarefa.tipoSinalizacao.idTipoSinalizacao != null &&
                                                                                            <span title="" data-tooltip={itemTarefa.tipoSinalizacao.tipoSinalizacaoDescricao} className="has-tooltip">
                                                                                                <IconFlag color={COR_SINALIZADORES[itemTarefa.tipoSinalizacao.idTipoSinalizacao] || "#CECECE"} />
                                                                                            </span>
                                                                                        }
                                                                                    </td>
                                                                                </tr>
                                                                            </React.Fragment>
                                                                        ))}
                                                                    </tbody>
                                                                </table>
                                                            </td>
                                                        </tr>
                                                    )}
                                                </React.Fragment>
                                            ))}
                                            <tr>
                                                <td colSpan={11}>
                                                    {(() => {
                                                        if (VisibilidadeData != null) {
                                                            return (
                                                                <PaginationCustom
                                                                    isMobile={isMobile}
                                                                    isDesktop={isDesktop}
                                                                    length={VisibilidadeData?.data?.page?.length ?? 0}
                                                                    recordsTotal={VisibilidadeData?.data?.page?.recordsTotal ?? 0}
                                                                    currentPage={currentPage ?? 0}
                                                                    formData={formData}
                                                                    pageSize={pageSize ?? 10}
                                                                    setPageSize={setPageSize}
                                                                    setPage={(page) => setCurrentPage(page)} />
                                                            )
                                                        }
                                                        return null
                                                    })()}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>

                                </div>
                                {itemDetalheChecked && (
                                    <></>
                                )}
                            </div>
                        ) : (
                            loadingData ? '' :
                                <div className="alert alert-warning" role="alert">
                                    <strong>Atenção!</strong> Nenhum processo foi encontrado. Por favor, adicione um novo filtro ou contate o administrador do sistema.
                                </div>
                        )}
                    </div>
                    <ModalVisibilidadeAcoes
                        key={"ModalVisibilidadeAcoes1"}
                        processo={selectedProcesso}
                        laudo={selectedProcessoLaudo}
                        isOpen={modalVisibilidadeAcoes}
                        onRequestClose={closeModalVisibilidadeAcoes}
                        setIsOpen={() => setModalVisibilidadeAcoes(false)}
                        aoSalvar={handleRefreshGrid}
                    >
                    </ModalVisibilidadeAcoes>

                    <ModalVisibilidadeTarefas
                        key={"ModalVisibilidadeTarefas1"}
                        idProcesso={modalIdProcesso}
                        laudo={selectedProcessoLaudo}
                        peritos={peritosList}
                        isOpen={modalVisibilidadeNovaTarefa}
                        onRequestClose={closeModalVisibilidadeNovaTarefa}
                        setIsOpen={() => setModalVisibilidadeNovaTarefa(false)}
                        aoSalvar={handleRefreshGrid}
                    >
                    </ModalVisibilidadeTarefas>

                    <ModalVisibilidadeAceitar
                        key={"ModalVisibilidadeAceitar1"}
                        processo={selectedProcessoModal}
                        laudo={selectedProcessoLaudo}
                        isOpen={modalVisibilidadeAceitar}
                        onRequestClose={closeModalVisibilidadeAceitar}
                        setIsOpen={() => setModalVisibilidadeAceitar(false)}
                        aoSalvar={handleRefreshGrid}
                    >
                    </ModalVisibilidadeAceitar>

                    <ModalVisibilidadeIniciar
                        key={"ModalVisibilidadeIniciar1"}
                        processo={selectedProcessoModal}
                        laudo={selectedProcessoLaudo}
                        isOpen={modalVisibilidadeIniciar}
                        onRequestClose={closeModalVisibilidadeIniciar}
                        setIsOpen={() => setModalVisibilidadeIniciar(false)}
                        aoSalvar={handleRefreshGrid}
                    >
                    </ModalVisibilidadeIniciar>

                    <ModalVisibilidadeRenovar
                        key={"ModalVisibilidadeRenovar1"}
                        processo={selectedProcessoModal}
                        laudo={selectedProcessoLaudo}
                        isOpen={modalVisibilidadeRenovar}
                        onRequestClose={closeModalVisibilidadeRenovar}
                        setIsOpen={() => setModalVisibilidadeRenovar(false)}
                        aoSalvar={handleRefreshGrid}
                    >
                    </ModalVisibilidadeRenovar>

                    <ModalVisibilidadeCancelar
                        key={"ModalVisibilidadeCancelar1"}
                        processo={selectedProcessoModal}
                        laudo={selectedProcessoLaudo}
                        isOpen={modalVisibilidadeCancelar}
                        onRequestClose={closeModalVisibilidadeCancelar}
                        setIsOpen={() => setModalVisibilidadeCancelar(false)}
                        aoSalvar={handleRefreshGrid}
                    >
                    </ModalVisibilidadeCancelar>

                    <ModalVisibilidadeTransferir
                        key={"ModalVisibilidadeTransferir1"}
                        processo={selectedProcessoModal}
                        laudo={selectedProcessoLaudo}
                        peritos={peritosList}
                        isOpen={modalVisibilidadeTransferir}
                        onRequestClose={closeModalVisibilidadeTransferir}
                        setIsOpen={() => setModalVisibilidadeTransferir(false)}
                        aoSalvar={handleRefreshGrid}
                    ></ModalVisibilidadeTransferir>

                    <ModalVisibilidadePriorizacao
                        key={"ModalVisibilidadePriorizacao1"}
                        tipoPrioridadeList={tipoPrioridadeType}
                        isOpen={modalVisibilidadePriorizacao}
                        onRequestClose={closeModalVisibilidadePriorizacao}
                        setIsOpen={() => setModalVisibilidadePriorizacao(false)}
                        aoSalvar={handleRefreshGrid}
                    ></ModalVisibilidadePriorizacao>

                    <ModalVisibilidadeExportar
                        key={"ModalVisibilidadeExportar1"}
                        isOpen={modalVisibilidadeExportar}
                        onRequestClose={closeModalVisibilidadeExportar}
                        setIsOpen={() => setModalVisibilidadeExportar(false)}
                        onExportar={handleExportarRelatorio}
                    ></ModalVisibilidadeExportar>

                    <ModalVisibilidadeMensagens
                        key={"ModalVisibilidadeMensagens1"}
                        processo={selectedProcessoModal}
                        tarefa={selectedTarefa}
                        isOpen={modalVisibilidadeMensagens}
                        isTarefa={isTarefaModal}
                        onRequestClose={closeModalVisibilidadeMensagens}
                        setIsOpen={() => setModalVisibilidadeMensagens(false)}
                        aoSalvar={handleRefreshGrid}
                    ></ModalVisibilidadeMensagens>

                    <ModalVisibilidadeDRL
                        key={"ModalVisibilidadeDRL1"}
                        processo={selectedProcessoModal}
                        tarefa={selectedTarefa}
                        isOpen={modalVisibilidadeDRL}
                        onRequestClose={closeModalVisibilidadeDRL}
                        setIsOpen={() => setModalVisibilidadeDRL(false)}
                        aoSalvar={handleRefreshGrid}
                    >
                    </ModalVisibilidadeDRL>

                    <ModalVisibilidadeConfiguracoes
                        key={"ModalVisibilidadeConfiguracoes"}
                        processo={selectedProcessoModal}
                        coberturaStatusType={coberturaStatusType}
                        statusDocumentacao={statusDocumentacao}
                        peritosList={peritosList}
                        isOpen={modalVisibilidadeConfiguracoes}
                        onRequestClose={closeModalVisibilidadeConfiguracoes}
                        setIsOpen={() => setModalVisibilidadeConfiguracoes(false)}
                        aoSalvar={handleRefreshGrid}
                    >
                    </ModalVisibilidadeConfiguracoes>
                </StyledVisibillidadePage>
            </main>
        </section>
    );
}

export const VisibilidadePage = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    return (
        <>
            {isMenuOpen ? (
                <MenuPage
                    isMenuOpen={isMenuOpen}
                    setIsMenuOpen={setIsMenuOpen}
                />
            ) : (
                <>
                    <Header
                        isMenuOpen={isMenuOpen}
                        setIsMenuOpen={setIsMenuOpen}
                    />
                    <Visibilidade />
                </>
            )}
        </>
    );
}